import React from 'react';
import Header from 'gatsby-theme-carbon/src/components/Header';

const CustomHeader = (props) => (
  <Header {...props}>
    <span>Kubernetes </span>&nbsp; Training
  </Header>
);

export default CustomHeader;
